module.exports = __webpack_public_path__ + "img/addregistericon_disabled.1acabde9.svg";